import { whiteColor } from "@config"
import createPage from "@src/components/page"
import React from "react"
import * as styles from "./pageLiked.module.scss"

import d1Img from "@images/png/18.png"
import Numbers from "@src/components/numbers"
import { callYou, useEnteringTrail } from "@src/components/page/lib"
import { animated } from "@react-spring/web"
import bgImg from "@images/2022/p11/43-100.jpg"
import faceImg from "@images/2022/p11/44.png"
import handImg from "@images/2022/p11/45.png"
import heartImg from "@images/2022/p11/46.png"
import starImg from "@images/2022/p11/47.png"

const parseData = ({
  attributes: {
    "bookmarked-count": bookmarked,
    "liked-count": liked,
    "shared-count": shared,
    "portfolio-subscriptions-count": portfolioSubs,
  },
}) => ({
  bookmarked,
  liked,
  shared,
  portfolioSubs,
})

const PageLiked = createPage(
  ({ data, offset }) => {
    const target = callYou(data)
    const { bookmarked, liked, shared, portfolioSubs } = parseData(data)
    const anime1Styles = useEnteringTrail(4, offset, { type: "mlt" })
    const anime2Styles = useEnteringTrail(4, offset, { step: 0.4 })
    return (
      <>
        <div>
          <div className="iconsGroup">
            <div>
              <animated.img
                style={anime1Styles[0]}
                src={starImg}
                className={styles.star}
                alt="icon"
              />
              <animated.img
                style={anime1Styles[1]}
                src={handImg}
                className={styles.hand}
                alt="icon"
              />
              <animated.img
                style={anime1Styles[2]}
                src={heartImg}
                className={styles.heart}
                alt="icon"
              />
              <animated.img
                style={anime1Styles[3]}
                src={faceImg}
                className={styles.face}
                alt="icon"
              />
            </div>
          </div>
        </div>

        <div>
          {portfolioSubs > 0 && (
            <animated.p style={anime2Styles[0]}>
              2022年有<b>{portfolioSubs}</b>人订阅了
              <br />
              {target}的作品集
            </animated.p>
          )}

          {(liked > 0 || shared > 0 || bookmarked > 0) && (
            <animated.div style={anime2Styles[1]}>今年发布内容</animated.div>
          )}
          {liked > 0 && (
            <animated.div style={anime2Styles[1]}>
              被点赞
              <b>{liked}</b>次
            </animated.div>
          )}
          {shared > 0 && (
            <animated.div style={anime2Styles[2]}>
              被分享
              <b>{shared}</b>次
            </animated.div>
          )}
          {bookmarked > 0 && (
            <animated.div style={anime2Styles[3]}>
              被收藏
              <b>{bookmarked}</b>次
            </animated.div>
          )}
        </div>
      </>
    )
  },
  {
    className: "pageLayout1",
  }
)

export const pageLikedData = {
  key: "liked",
  bgImg,
  Page: PageLiked,
  shouldHide: (data) => {
    const { bookmarked, liked, shared, portfolioSubs } = parseData(data)
    return (
      bookmarked === 0 && liked === 0 && shared === 0 && portfolioSubs === 0
    )
  },
}

PageLiked.displayName = "PageLiked"
export default PageLiked
